import React from 'react';
import { History } from 'lucide-react';
import { formatRelativeInZone } from '../../lib/timezone';

export default function ActivityEditHistory({ activity, displayZone }) {
    const entries = Array.isArray(activity?.edit_log) ? activity.edit_log : [];
    if (!entries.length) return null;
    const labelFor = (change) => change.field === 'owner_id' ? 'Assignee' : (change.label || change.field);
    const oldValue = change => change.old_label ?? change.old ?? '(empty)';
    const newValue = change => change.new_label ?? change.new ?? '(empty)';
    return (
        <div className="mt-3 pt-2 border-t border-stone-100" data-testid="activity-edit-history">
            <div className="flex items-center gap-1.5 text-[11px] text-stone-500">
                <History className="w-3 h-3" />
                <span>Edited by <span className="font-medium text-stone-700">{entries[entries.length - 1]?.user_name || 'Unknown'}</span></span>
            </div>
            <div className="mt-1.5 space-y-1.5 pl-3 border-l border-stone-100">
                {[...entries].reverse().flatMap((entry, entryIndex) => (entry.changes || []).map((change, changeIndex) => (
                    <div key={`${entry.log_id || entryIndex}-${changeIndex}`} className="text-[10px] text-stone-500">
                        <span className="font-medium">{labelFor(change)}:</span> {oldValue(change)} → {newValue(change)}
                        {entry.timestamp && <span className="ml-1 text-stone-400">· {formatRelativeInZone(entry.timestamp, { zone: displayZone })}</span>}
                    </div>
                )))}
            </div>
        </div>
    );
}
